import { render, staticRenderFns } from "./VbgDashboardRoot.vue?vue&type=template&id=b8d13c56&scoped=true"
import script from "./VbgDashboardRoot.vue?vue&type=script&lang=js"
export * from "./VbgDashboardRoot.vue?vue&type=script&lang=js"
import style0 from "./VbgDashboardRoot.vue?vue&type=style&index=0&id=b8d13c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d13c56",
  null
  
)

export default component.exports